import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

function useLinkSellScanner() {
  const { t } = useTranslation();
  const history = useHistory();
  const cartData = useSelector((state) => state.cartData);

  const [isQRScannerOpen, setIsQRScannerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});

  const onSingleProductScan = (data) => {
    const { token: customerToken = null, user = null } = data || {};

    if (!customerToken || !user) {
      window.alert(t("customerRedemption.invalidCode"));
      return;
    }

    history.push({
      pathname: "/checkout",
      state: { productID: selectedProduct._id, customerToken },
      // state: { productID: data._id },
    });
  };

  const onCartScan = (data) => {
    const { token: customerToken = null, user = null } = data || {};

    if (!customerToken || !user) {
      window.alert(t("customerRedemption.invalidCode"));
      return;
    }

    history.push({
      pathname: "/checkout",
      state: { cartID: cartData._id, customerToken },
    });
  };

  return {
    isQRScannerOpen,
    setIsQRScannerOpen,
    setSelectedProduct,
    onSingleProductScan,
    onCartScan,
  };
}

const QRCodeScannerHooks = { useLinkSellScanner };

export default QRCodeScannerHooks;
